import React from 'react';
import { ENDS_SELECT_OPTIONS, FrequencySelectOptions, FrequencyType } from 'components/FrequencySelectBlock/FrequencySelectBlock';
import { CalendarIcon, MapPinIcon, RepeatIcon } from 'components/Icons';
import { TriggerPreviewOptions, TriggerTypes } from 'components/TriggerSelectBlock/TriggerSelectBlock';
import { Text } from 'components/Typography';
import { Color } from 'utils/color';
import { formatTimeRange, formatMonthDay } from 'utils/time';
import styles from './ConditionsPreview.scss';

type Props = {
  frequency: FrequencyType;
  trigger?: TriggerTypes;
  selectedDateTime: Date | null;
  expiredDateTime: Date | null;
};

export const ConditionsPreview: React.FC<Props> = ({ frequency, trigger, selectedDateTime, expiredDateTime }) => {
  return (
    <div className={styles.container}>
      <div className={styles.rowWrapper}>
        <CalendarIcon width={18} height={18} />
        <Text variant="md" color={Color.GRAY}>
          {`${formatTimeRange(selectedDateTime, expiredDateTime)}`}
        </Text>
      </div>
      <div className={styles.rowWrapper}>
        <RepeatIcon width={18} height={18} />
        <Text variant="md" color={Color.GRAY}>
          {`${FrequencySelectOptions[frequency.repeat]}`}
          {frequency.ends === ENDS_SELECT_OPTIONS.after && !!frequency.after && `, ${frequency.after} time${frequency.after > 1 ? 's' : ''}`}
          {frequency.ends === ENDS_SELECT_OPTIONS.date && !!frequency.date && ` until ${formatMonthDay(frequency.date)}`}
        </Text>
      </div>
      {!!trigger && (
        <div className={styles.rowWrapper}>
          <MapPinIcon width={18} height={18} />
          <Text variant="md" color={Color.GRAY}>
            {TriggerPreviewOptions[trigger]}
          </Text>
        </div>
      )}
    </div>
  );
};
